module.exports = __webpack_public_path__ + "ba83bbc41789f3dea18a1a942e52c5bc.pdf";